import { Component } from "@angular/core";

@Component({ templateUrl: "courselocked.component.html" })
export class CourseLockedComponent {
  constructor() {}
}
